import { Text } from '@chakra-ui/react'

const ImportantStar = ({ ...props }) => (
    <Text as={'span'} color={'pomegranate'} {...props}>
        *
    </Text>
)

export default ImportantStar
